var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',[_c('transition-group',{attrs:{"name":"chatList","tag":"p"}},_vm._l((_vm.homeChat),function(item,ix){return _c('QCard',{key:("item-trans-home-" + ix),attrs:{"content":item.content}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }